module.exports = "<figure ng-bind-html=\"$ctrl.iconSVG\"></figure>";